import type { OperationsNode } from '../types/operations.types'

/**
 * Depth-first lookup by node id, or null when the id is not in the tree.
 *
 * Shared rather than redefined per module: the drop resolver, the preview and
 * the pending-move applier all need it, and three private copies were three
 * places for the traversal to drift.
 */
export const findNodeById = (
  nodes: OperationsNode[],
  id: string
): OperationsNode | null => {
  for (const node of nodes) {
    if (node.id === id) {
      return node
    }
    const found = findNodeById(node.children, id)
    if (found) {
      return found
    }
  }
  return null
}
